export const formRules = {
  name: [{ required: true, message: "请输入材料名称" }],
  model: [{ required: true, message: "请输入规格型号" }],
  materialCategoryId: [{ required: true, message: "请选择所属分类" }],
  unitId: [{ required: true, message: "请选择结算单位" }],
  materialCategoryBrandId: [{ required: true, message: "请选择材料品牌" }],
};
